import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { HistoryEntry } from "@/components/deck/HistoryEntry";

const TYPES = [["", "Everything"], ["players", "Players"], ["brackets", "Brackets"], ["chronicles", "Archived seasons"],
  ["intake", "Season intake"], ["leaders", "Leader accounts"], ["pantheon", "Pantheon"], ["heroes", "Hero Codex"], ["other", "Other"]];

export const HistoryPanel = ({ open, onClose }) => {
  const [by, setBy] = useState("");
  const [type, setType] = useState("");
  const [data, setData] = useState(null);
  const [more, setMore] = useState(false);

  const load = async (before = "") => {
    try {
      const { data: d } = await api.get("/audit", { params: { by, type, before, limit: 100 } });
      setData((old) => (before && old ? { ...d, entries: [...old.entries, ...d.entries] } : d));
      setMore(d.entries.length === 100);
    } catch (e) { toast.error(errMsg(e)); }
  };
  useEffect(() => { if (open) load(); }, [open, by, type]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!open) return null;
  const entries = data?.entries || [];
  return (
    <aside className="lg lg-inbox lg-intake" data-testid="history-panel">
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
        <h3 style={{ fontSize: 18, margin: 0, marginRight: "auto" }}>Change history</h3>
        <button className="lg-btn ghost sm" onClick={onClose} data-testid="history-close"><X size={14} /></button>
      </div>
      <p style={{ fontSize: 13, color: "var(--muted)", marginBottom: 12 }}>Who changed what, newest first. Bulk changes like publishing an intake show as one line.</p>
      <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
        <select className="lg-input" value={by} onChange={(e) => setBy(e.target.value)} data-testid="history-filter-leader">
          <option value="">All leaders</option>
          {(data?.leaders || []).map((l) => <option key={l} value={l}>{l}</option>)}
        </select>
        <select className="lg-input" value={type} onChange={(e) => setType(e.target.value)} data-testid="history-filter-type">
          {TYPES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
      </div>
      {!data && <p>Loading…</p>}
      {data && !entries.length && <p style={{ color: "var(--muted)" }} data-testid="history-empty">No changes recorded yet for this filter.</p>}
      {entries.map((e) => <HistoryEntry key={e.id} e={e} />)}
      {more && <button className="lg-btn ghost sm" onClick={() => load(entries[entries.length - 1].at)} data-testid="history-load-more">Load older</button>}
    </aside>
  );
};
